import React, { useCallback, useContext, useEffect } from "react";
import { format } from "date-fns";
import useWhiteLabelConfig from "@hooks/useWhiteLabelConfig";
import { ApplicationContext } from "@context/ApplicationContext";
import { AuthContext } from "@context/AuthContext";
import { UserContext } from "@context/UserContext";
import { generateCalendarLinks } from "@components/AddToCalendar";
import TicketingConfirmation from "@components/TicketingConfirmation";
import VoucherSessionConfirmation from "@components/VoucherSessionConfirmation";
import "./style.scss";


const parseSessionDate = (dateStr) => {
    if (!dateStr) return null;
    return dateStr.replace(/\.\d+$/, "").replace(" ", "T");
};


const ConfirmationMessage = ({
                                 purchasedTicket,
                                 purchasedSession,
                                 tempAccountCreation,
                                 isTicketingSystemPurchase,
                             }) => {
    const { user } = useContext(AuthContext);
    const { fetchTickets, purchasedVouchers } = useContext(UserContext);
    const { whiteLabel } = useContext(ApplicationContext);
    const { isGuestExperienceEnabled } = useWhiteLabelConfig();


    const stableFetchTickets = useCallback(fetchTickets, []);
    useEffect(() => {
        stableFetchTickets();
    }, [stableFetchTickets]);


    const lastPurchase = purchasedVouchers?.[purchasedVouchers.length - 1];

    if (!lastPurchase) return null;

    const isBypassActive =
        whiteLabel?.subscriber_group?.bypass_lets_get_started === true;

    const sessionDateStr = parseSessionDate(purchasedSession?.session_date?.date);
    const formattedDate = sessionDateStr
        ? format(new Date(sessionDateStr), "do MMM")
        : "";
    const formattedTime = sessionDateStr
        ? format(new Date(sessionDateStr), "h:mm a")
        : "";

    const ticketCount = purchasedTicket?.total_tickets || 0;
    const displayWord = ticketCount > 1 ? "Vouchers" : "Voucher";

    const calendarLinks =
        lastPurchase && purchasedSession
            ? generateCalendarLinks(lastPurchase, purchasedSession)
            : null;

    if (isTicketingSystemPurchase) {
        if (!purchasedSession || !lastPurchase) return null;

        return (
            <TicketingConfirmation
                user={user}
                purchasedSession={purchasedSession}
                purchasedTicket={purchasedTicket}
                lastPurchase={lastPurchase}
                tempAccountCreation={tempAccountCreation}
                isBypassActive={isBypassActive}
                isGuestExperienceEnabled={isGuestExperienceEnabled}
                hideProfileMenu={whiteLabel?.hide_profile_menu}
            />
        );
    }

    if (!purchasedSession || !purchasedTicket || !lastPurchase) return null;

    return (
        <VoucherSessionConfirmation
            purchasedSession={purchasedSession}
            purchasedTicket={purchasedTicket}
            lastPurchase={lastPurchase}
            formattedDate={formattedDate}
            formattedTime={formattedTime}
            calendarLinks={calendarLinks}
            tempAccountCreation={tempAccountCreation}
            isBypassActive={isBypassActive}
            preferredName={whiteLabel?.preferred_name}
            displayWord={displayWord}
            ticketCount={ticketCount}
        />
    );
};

export default ConfirmationMessage;
